import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ListEntityParams {
  name?: string;
  listId?: number | string;
  query?: string;
  service?: string;
  linkText?: string;
}
export class ListEntity extends BaseEntityClass {
  name?: string;
  listId?: number | string;
  query?: string;
  service?: string;
  linkText?: string;
  constructor(params: ListEntityParams) {
    super();
    this.type = "list";
    this.entity_version = 2;
    this.name = params.name;
    this.listId = params.listId;
    this.query = params.query;
    this.service = params.service;
    this.linkText = params.linkText;
  }
}
